import { useState } from 'react';
import { AppBar as MuiAppBar, Toolbar, IconButton, Box, useMediaQuery, Tooltip, Container, Typography } from '@mui/material';
import { AssistantRounded, Menu as MenuIcon } from '@mui/icons-material';
import Breadcrumbs from 'components/Breadcrumbs';
import UserMenu from 'components/UserMenu';
import TaskBar from 'components/TaskBar';
import theme from 'theme';
import AiAssistent from 'components/AiAssistent';

function AppBar(props) {
  const isMobile = useMediaQuery(theme.breakpoints.up('sm'));
  const [aiAssistentModal, setAiAssistentModal] = useState(false);

  return (
    <>
      <MuiAppBar
        elevation={0}
        position='fixed'
        sx={{
          background: '#E4E4E4', //theme.palette.highlight.main,
          color: '#353A40',
          borderBottom: '2px solid #009A7D',
          width: { sm: `calc(100% - ${props.drawerWidth}px)` }
        }}
      >
        <Toolbar variant='dense'>
          <IconButton
            color='inherit'
            aria-label='open drawer'
            edge='start'
            onClick={props.handleDrawerToggle}
            sx={{ mr: 2, display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          {isMobile &&
            <Breadcrumbs />
          }
          <Box sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end', paddingX: 2, gap: 1 }}>
            <Tooltip title="Assistente Prax-IA">
              {/* <IconButton onClick={() => setAiAssistentModal(true)}>
            <AssistantRounded/>
            </IconButton> */}
            </Tooltip>
            <TaskBar />
          </Box>
          <UserMenu />
          <AiAssistent
            isOpen={aiAssistentModal}
            onClose={() => setAiAssistentModal(false)}
          />
        </Toolbar>
      </MuiAppBar>
    </>

  )
} export default AppBar;